module.exports = __webpack_public_path__ + "img/code.b04e8e80.png";